import { render, staticRenderFns } from "./BeuticianDataSheetsList.vue?vue&type=template&id=500d5a20"
import script from "./BeuticianDataSheetsList.vue?vue&type=script&lang=js"
export * from "./BeuticianDataSheetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports